import { mapState } from "vuex";

export default {
    beforeMount() {
        this.$store.dispatch('dashboard/fetchGraphData', { userId: this.currentUser.uid })
            .then((x) => {
                setTimeout(() => {
                    this.generateGraph();
                }, 1000)
            })
            .catch((e) => console.log(e.toString()));
    },
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            userProfileLoaded: state => state.userProfileLoaded,
            currentUser: state => state.currentUser,
        }),
        ...mapState('dashboard', {
            statsScoreByDay: state => state.statsScoreByDay,
            statsLoaded: state => state.statsLoaded,
        }),
    },
    methods: {

        /**
         * Generate the chart for the user's statistics
         * Should be called only after statsScoreByDay is setted into the Dashboard's Store
         */
        generateGraph() {

            let vm = this;

            "use strict";

            // Class definition
            let KTWidgets = function() {

                let _initMixedWidget17 = function() {
                    var element = document.getElementById("kt_mixed_widget_17_chart");
                    var color = KTUtil.hasAttr(element, 'data-color') ? KTUtil.attr(element, 'data-color') : 'primary';
                    var height = parseInt(KTUtil.css(element, 'height'));

                    if (!element) {
                        return;
                    }

                    var options = {
                        series: [{
                            name: 'Points evolution',
                            data: [vm.statsScoreByDay[5].toString(), vm.statsScoreByDay[4].toString(), vm.statsScoreByDay[3].toString(), vm.statsScoreByDay[2].toString(), vm.statsScoreByDay[1].toString(), vm.statsScoreByDay[0].toString()]
                        }],
                        chart: {
                            type: 'area',
                            height: height,
                            toolbar: {
                                show: false
                            },
                            zoom: {
                                enabled: false
                            },
                            sparkline: {
                                enabled: true
                            }
                        },
                        plotOptions: {},
                        legend: {
                            show: false
                        },
                        dataLabels: {
                            enabled: false
                        },
                        fill: {
                            type: 'solid',
                            opacity: 1
                        },
                        stroke: {
                            curve: 'smooth',
                            show: true,
                            width: 3,
                            colors: [KTApp.getSettings()['colors']['theme']['base'][color]]
                        },
                        xaxis: {
                            categories: ['J-5', 'J-4', 'J-3', 'J-2', 'J-1', 'Today'],
                            axisBorder: {
                                show: false,
                            },
                            axisTicks: {
                                show: false
                            },
                            labels: {
                                show: false,
                                style: {
                                    colors: KTApp.getSettings()['colors']['gray']['gray-500'],
                                    fontSize: '12px',
                                    fontFamily: KTApp.getSettings()['font-family']
                                }
                            },
                            crosshairs: {
                                show: false,
                                position: 'front',
                                stroke: {
                                    color: KTApp.getSettings()['colors']['gray']['gray-300'],
                                    width: 1,
                                    dashArray: 3
                                }
                            },
                            tooltip: {
                                enabled: true,
                                formatter: undefined,
                                offsetY: 0,
                                style: {
                                    fontSize: '12px',
                                    fontFamily: KTApp.getSettings()['font-family']
                                }
                            }
                        },
                        yaxis: {
                            min: 0,
                            max: 250,
                            labels: {
                                show: false,
                                style: {
                                    colors: KTApp.getSettings()['colors']['gray']['gray-500'],
                                    fontSize: '12px',
                                    fontFamily: KTApp.getSettings()['font-family']
                                }
                            }
                        },
                        states: {
                            normal: {
                                filter: {
                                    type: 'none',
                                    value: 0
                                }
                            },
                            hover: {
                                filter: {
                                    type: 'none',
                                    value: 0
                                }
                            },
                            active: {
                                allowMultipleDataPointsSelection: false,
                                filter: {
                                    type: 'none',
                                    value: 0
                                }
                            }
                        },
                        tooltip: {
                            style: {
                                fontSize: '12px',
                                fontFamily: KTApp.getSettings()['font-family']
                            },
                            y: {
                                formatter: function(val) {
                                    return "+" + val + " point(s)"
                                }
                            }
                        },
                        colors: [KTApp.getSettings()['colors']['theme']['light'][color]],
                        markers: {
                            colors: [KTApp.getSettings()['colors']['theme']['light'][color]],
                            strokeColor: [KTApp.getSettings()['colors']['theme']['base'][color]],
                            strokeWidth: 3
                        }
                    };

                    var chart = new ApexCharts(element, options);
                    chart.render();
                }

                return {
                    init: function () {
                        _initMixedWidget17();
                    }
                }
            }();

            jQuery(document).ready(function() {
                KTWidgets.init();
            });

        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/components/overview/dashboard-stats/dashboard-stats.js